import React from "react";
import { Link } from "react-router";
import { Box, Typography } from "@mui/material";
import CellTowerIcon from "@mui/icons-material/CellTower";

type BrandProps = {
  to: string;
  tagline?: string;
  hideWordmarkOnMobile?: boolean;
};

const Brand: React.FC<BrandProps> = ({ to, tagline, hideWordmarkOnMobile = false }) => (
  <Box
    component={Link}
    to={to}
    aria-label="STR Monitoring"
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      textDecoration: "none",
      color: "inherit",
      flexShrink: 0,
      "&:hover .logo-mark": { transform: "scale(1.05)" },
    }}
  >
    <Box
      className="logo-mark"
      sx={{
        width: 40,
        height: 40,
        borderRadius: "12px",
        background: "linear-gradient(135deg, #7c3aed, #6366f1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 10px 25px rgba(124, 58, 237, 0.3)",
        transition: "transform 0.2s ease",
      }}
    >
      <CellTowerIcon sx={{ color: "#fff", fontSize: 20 }} />
    </Box>
    <Box sx={{ display: hideWordmarkOnMobile ? { xs: "none", sm: "block" } : "block" }}>
      <Typography
        sx={{
          fontSize: "1.25rem",
          fontWeight: 800,
          letterSpacing: "-0.02em",
          lineHeight: 1.1,
          color: "#fff",
        }}
      >
        STR
        <Box component="span" sx={{ color: "#a78bfa" }}>
          Monitoring
        </Box>
      </Typography>
      {tagline && (
        <Typography
          sx={{
            fontSize: "0.625rem",
            color: "#94a3b8",
            fontWeight: 500,
            letterSpacing: "0.04em",
          }}
        >
          {tagline}
        </Typography>
      )}
    </Box>
  </Box>
);

export default Brand;
